<template>
    <fade-up-animation :element="() => $refs.section">
        <section class="restaurant-list-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <h2 class="title" v-test:title>{{ title }}</h2>
                    <b-row>
                        <b-col xl="10" offset-xl="1">
                            <base-carousel
                                :breakpoints="carouselBreakpoints"
                                :always-show-navigation="showNavigationButtons"
                                center-insufficient-slides
                                navigation
                            >
                                <restaurant-card
                                    v-for="(restaurant, i) in restaurants"
                                    :slot="`slot_${ i }`"
                                    :key="`slot_${ i }`"
                                    :to="restaurant.to"
                                    :image="restaurant.image"
                                    :title="restaurant.title"
                                    :address="restaurant.address"
                                />
                            </base-carousel>
                        </b-col>
                    </b-row>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-up-animation>
</template>

<script>
    import RestaurantCard from '../../molecules/RestaurantCard/RestaurantCard';
    import BaseCarousel from '../../molecules/BaseCarousel/BaseCarousel';

    export default {
        name: 'restaurant-list-section',

        components: { BaseCarousel, RestaurantCard },

        props: {
            title: {
                type: String,
                required: true,
            },

            restaurants: {
                type: Array,
                required: true,
            },

            showNavigationButtons: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            /**
             * Return the carousel breakpoints.
             *
             * @returns {object}
             */
            carouselBreakpoints() {
                return {
                    0: {
                        slidesPerView: 1,
                    },
                    400: {
                        slidesPerView: 1.75,
                    },
                    768: {
                        slidesPerView: 2.5,
                    },
                    992: {
                        slidesPerView: 3.5,
                    },
                    1377: {
                        slidesPerView: 5,
                    },
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .restaurant-list-section {
        padding-top: 55px;
        padding-bottom: 20px
    }

    .title {
        text-align: center;
        font-size: rem(32px);
        line-height: rem(36px);
        font-weight: 700;
        margin-bottom: 21px;

        @include media-breakpoint-up(lg) {
            font-size: rem(40px);
            line-height: rem(44px);
        }
    }

    ::v-deep .swiper-slide {
        padding: 5px;
    }
</style>
